import Query from '../../Query.js';
import { OrgDetailReturnFields } from '../returnFields';

/**
 * Get an Organization.
 *
 * @param {Object} where - Fields to search by.
 * @param {String[]} additionalFields - Additional fields to return from the back-end.
 *
 * @returns {Promise<{ org?: Record<string, any>, errors?: import('graphql').GraphQLError[] }>} res - { errors, org }
 */
const getOrganizationWhere = async function( where, additionalFields = [] ) {
	const res = await this.request(
		new Query( {
			type: 'query',
			name: 'getOrganizationWhere',
			params: { where },
			returnFields: OrgDetailReturnFields.concat( additionalFields ),
		} )
	);

	if ( !res.errors ) {
		return {
			org: res.data.data.getOrganizationWhere,
			errors: res.data.errors,
		};
	}

	return { errors: res.errors };
};

const getConnectOnboardingUrl = async function( { return_url, type } ) {
	const res = await this.request(
		new Query( {
			type: 'query',
			name: 'getConnectOnboardingUrl',
			params: {
				data: {
					type,
					return_url,
				},
			},
			returnFields: [ 'url' ],
		} )
	);
	if ( res.data && res.data.data && res.data.data.getConnectOnboardingUrl ) {
		return { url: res.data.data.getConnectOnboardingUrl.url };
	}
};

export { getConnectOnboardingUrl, getOrganizationWhere };
